import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.796 4.4a.3.3 0 0 0-.3.3v10.6a.3.3 0 0 0 .3.3h8.408a.3.3 0 0 0 .3-.3V8.2H12.5a1.7 1.7 0 0 1-1.7-1.7V4.4H5.796ZM12.2 5.42l1.344 1.38H12.5a.3.3 0 0 1-.3-.3V5.42ZM4.096 4.7a1.7 1.7 0 0 1 1.7-1.7H11.5a.7.7 0 0 1 .501.211l3.705 3.8a.7.7 0 0 1 .198.489v7.8a1.7 1.7 0 0 1-1.7 1.7H5.796a1.7 1.7 0 0 1-1.7-1.7V4.7Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.182 9.76v2.286l1.932-1.143L9.182 9.76Zm.462-1.354A1.233 1.233 0 0 0 7.782 9.47v2.869c0 .955 1.04 1.547 1.861 1.062l2.426-1.435a1.235 1.235 0 0 0 0-2.124L9.644 8.406Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=VideoFileIcon20.js.map